export default __webpack_public_path__ + "static/media/7884951950305ae4f0323f009213ea91.png";